import { ReactElement } from 'react';
import Big from 'big.js';
import { Stack, Box, DialogBody, DialogClose, DialogFooter, DialogHeader } from '@ff-it/ui';
import { DecimalField, Form, Submit, useSubmitHandler } from '@ff-it/form';
import { composeValidators, parseBig, positive, required } from 'utilities';
import { ApplicationResponse, LinkCandidate } from 'modules/applicator/types';
import { InvoiceWidget } from 'modules/invoicing/common/InvoiceWidget';

type ApplyFormProps = {
  url: string;
  balance: Big;
  onSubmit: (data: ApplicationResponse) => void;
  candidate: LinkCandidate;
};

export function ApplyForm({
  url,
  balance,
  candidate: { destination, amount: candidateBalance },
  onSubmit: onSuccess,
}: ApplyFormProps): ReactElement {
  const submitHandler = useSubmitHandler({ url, method: 'POST' }, { onSuccess });

  const validate = composeValidators(required, positive, (value: any) =>
    parseBig(value).gt(balance) ? `Has to be less or equeal to ${balance.toFixed()}` : undefined,
  );

  return (
    <Form initialValues={{ amount: candidateBalance, destination: destination.id }} onSubmit={submitHandler}>
      <DialogHeader title="Add invoice" />
      <DialogBody>
        <Stack direction="horizontal">
          <Box width="full">
            <InvoiceWidget invoice={destination} />
          </Box>
          <Box width="full" px="4">
            <div className="form-control form-control-plaintext font-weight-bold">{candidateBalance}</div>
          </Box>
          <Box width="full">
            <DecimalField name="amount" className="mb-0 text-right" required validate={validate} />
          </Box>
        </Stack>
      </DialogBody>
      <DialogFooter>
        <DialogClose />
        <Submit ml="auto" />
      </DialogFooter>
    </Form>
  );
}
